import React from 'react'
import createSvgIcon from '../utilities/createSvgIcon'

export default createSvgIcon(
  <>
    <path d="M20 2C21.1 2 22 2.9 22 4V15.3125C21.8687 15.351 21.74 15.4005 21.6152 15.4609L21.5957 13.9814L21.5791 13.7266C21.4346 12.4677 20.3577 11.4978 19.0635 11.5146C17.7691 11.5317 16.7168 12.5297 16.6055 13.792L16.5967 14.0479L16.6143 15.416C15.7051 15.0329 14.6157 15.2115 13.875 15.9521C13.3154 16.5117 13.0784 17.2703 13.1602 18H6L2 22L2.00977 4C2.00977 2.9 2.9 2 4 2H20ZM6 12V14H14V12H6ZM6 9V11H18V9H6ZM6 6V8H18V6H6Z" />
    <path
      d="M19.096 14.0145L19.1682 19.4874M15.6425 17.7196L19.1781 21.2551M19.1682 21.2451L22.7037 17.7096"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="2"
    />
  </>,
  'ChatDownload',
)
